// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
// UI reducer types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOADING_DATA = 'LOADING_DATA';
export const STOP_LOADING_UI = 'STOP_LOADING_UI';
export const REPLACE_IMAGES = 'REPLACE_IMAGES';
// Data reducer types
export const SET_HOLLAS = 'SET_HOLLAS';
export const SET_HOLLA = 'SET_HOLLA';
export const LIKE_HOLLA = 'LIKE_HOLLA';
export const UNLIKE_HOLLA = 'UNLIKE_HOLLA';
export const DELETE_HOLLA = 'DELETE_HOLLA';
export const POST_HOLLA = 'POST_HOLLA';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';